export default __webpack_public_path__ + "static/media/payment-successful.2b3a90ad.gif";